import { itensValidos } from '../../manual-utils';
import {
  blocoTabela,
} from '../blocos';
import type { Bloco } from '../blocos';
import type { ItemEtapa } from '../../manual-types';

export function etapasParaTabela(etapas: ItemEtapa[], id: string, legenda: string): Bloco[] {
  const validas = itensValidos(etapas, ['descricao', 'observacao']);
  if (!validas.length) return [];
  return blocoTabela({
    id,
    legenda,
    colunas: ['N°', 'Procedimento', 'Observação'],
    linhas: validas.map((etapa, indice) => [String(indice + 1), etapa.descricao || '—', etapa.observacao || '—']),
    larguras: ['8%', '56%', '36%'],
    alinharEsquerda: true,
    porPagina: 16,
  });
}
